// React
import PropTypes from "prop-types";

// Components
import AccountsTable from "../admin-accounts/AccountsTable";

// Components
import Spinner from "../common/Spinner";

// API
import { useGetAllMappings } from "../../api/permissions/PermissionsAPI";
import isEmpty from "../../validation/is-empty";

SystemDashboardBenchmarkTable.propTypes = {
  accounts: PropTypes.object,
};

export default function SystemDashboardBenchmarkTable(props) {
  const { accounts } = props;
  const { allMappings } = useGetAllMappings("Benchmark");

  accounts?.data?.forEach((user) => {
    let permission = allMappings?.data?.find((p) => p.userGlobalId === user.id);
    user.collectionCount = 0;
    if (!isEmpty(permission)) {
      user.collectionCount = permission?.userMapping.length;
    }
  });

  if (isEmpty(allMappings.data) && allMappings.loading) {
    return (
      <div className="toggle-button-text-container">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="toggle-button-text-container">
      <p>
        <b>Benchmarking Analysis</b>
      </p>
      <AccountsTable accounts={accounts} />
    </div>
  );
}
